<template>
  <div class='home'>
    <Header :isShow="true"></Header>
    <div class='home-box'>
      <div class='one-text text'>IC Bench is The Future.</div>
      <div class='two-text text'>一路相伴，共创芯未来。</div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: 'home',
  data() {
    return {
      
    }
  },
  methods: {
    
  },
  created() {
    
  },
  components: {
    Header,
    Footer
  },
}
</script>
<style lang='less' scoped>

.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.home-box {
  width: 100vw;
  height: calc(100vh - 282px) ;
  background-image: url(../assets/home-page-gif.gif);
  background-size: cover;
  background-position: center;
  display: flex;
  text-align: left;
  flex-direction: column;
  justify-content: center;
  // align-items: center;
}

.text {
  color: #fff;
  font-size: 40px;
  font-weight: 900;
  margin-left: 140px;
}  
</style>